import { render, staticRenderFns } from "./CustomerOrderList.vue?vue&type=template&id=de8a3e80&scoped=true"
import script from "./CustomerOrderList.vue?vue&type=script&lang=js"
export * from "./CustomerOrderList.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderList.vue?vue&type=style&index=0&id=de8a3e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8a3e80",
  null
  
)

export default component.exports